import { createAction } from 'redux-actions';

export const setWATemplates = createAction('app/SET_WA_TEMPLATES');

export const setExistingCallToActionTypes = createAction(
  'app/SET_WA_TEMPLATES_CTA_TYPES'
);

export const setCurrentWATemplate = createAction('app/SET_CURRENT_WA_TEMPLATE');
export const resetCurrentWATemplate = createAction(
  'app/RESET_CURRENT_WA_TEMPLATE'
);

export const setWATemplatesPage = createAction('app/SET_WA_TEMPLATES_PAGE');
export const setWATemplatesSort = createAction('app/SET_WA_TEMPLATES_SORT');
export const setWATemplatesOrder = createAction('app/SET_WA_TEMPLATES_ORDER');
export const setWATemplatesSearch = createAction('app/SET_WA_TEMPLATES_SEARCH');
export const clearWATemplatesOpts = createAction('app/CLEAR_WA_TEMPLATES_OPTS');

export const setCurrentWATemplateWithVariables = createAction(
  'app/SET_CURRENT_WA_TEMPLATE_WITH_VARIABLES'
);
export const resetCurrentWATemplateWithVariables = createAction(
  'app/RESET_CURRENT_WA_TEMPLATE_WITH_VARIABLES'
);
